import React from "react";

export const MenuResidente = [
  // Dashboard
  {
    title: "Inicio",
    iconStyle: <i className="flaticon-025-dashboard"></i>,
    to: "dashboard-residente",
  },
  // Visitantes
  {
    title: "Visitantes",
    classChange: "mm-collapse",
    iconStyle: <i className="fas fa-users"></i>,
    content: [
      {
        title: "Historial",
        to: "visitantes",
      },
      {
        title: "Pre-registros",
        to: "pre-registros",
      },
    ],
  },
  // Zonas Sociales
  {
    title: "Zonas Sociales",
    classChange: "mm-collapse",
    iconStyle: <i className="fas fa-swimming-pool"></i>,
    content: [
      {
        title: "Zonas Disponibles",
        to: "zonas-sociales",
      },
      {
        title: "Mis Reservas",
        to: "mis-reservas",
      },
    ],
  },
  // Correspondencia
  {
    title: "Correspondencia",
    iconStyle: <i className="fas fa-envelope"></i>,
    to: "correspondencia",
  },
  // Autorizaciones
  {
    title: "Autorizaciones",
    classChange: "mm-collapse",
    iconStyle: <i className="fas fa-file-signature"></i>,
    content: [
      {
        title: "Mis Autorizaciones",
        to: "autorizaciones",
      },
      {
        title: "Nueva Autorización",
        to: "autorizacion-crear",
      },
    ],
  },
];
